'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../adapter/index.js');

class FAQsCategories {
  get(lang) {
    const params = { lang };
    return index.adapter.faqsCategories.get(params);
  }
}
const faqsCategories = new FAQsCategories();

exports.faqsCategories = faqsCategories;
